import { dashboardAction } from "../actionTypes"

const initialState = {
  stats: {},
  loader: false,
}

export default function dashboard(state = initialState, { type, payload }) {
  switch (type) {
    case dashboardAction.DASHBOARD_INITIATE:
      return { ...state, loader: true }
    case dashboardAction.DASHBOARD_SUCCESS:
      return { ...state, loader: false, stats: payload.data }
    case dashboardAction.DASHBOARD_FAILURE:
      return { ...state, loader: false }
    default:
      return state
  }
}
